export default __webpack_public_path__ + "static/media/france.40c79af5.svg";